import { render, staticRenderFns } from "./SellWaterRecord.vue?vue&type=template&id=83680f1c&scoped=true"
import script from "./SellWaterRecord.vue?vue&type=script&lang=js"
export * from "./SellWaterRecord.vue?vue&type=script&lang=js"
import style0 from "./SellWaterRecord.vue?vue&type=style&index=0&id=83680f1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83680f1c",
  null
  
)

export default component.exports